import * as React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';

import LoadingAnimation from '../../components/loading-animation';

/**
 * Full content area view with loading animation.
 */
export const LoadingView = () => (
  <Box style={styles.contentLoadingContainer}>
    <LoadingAnimation />
  </Box>
);

const styles = StyleSheet.create({
  contentLoadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
